import React from "react";
import { TouchableWithoutFeedback } from "react-native";
import AnalyticsManager from "../../common/AnalyticsManager";

export default function PrestoTouchableWithoutFeedback({
  eventName,
  eventAttr,
  onPress,
  ...props
}) {
  return (
    <TouchableWithoutFeedback
      {...props}
      onPress={() => {
        if (eventName) {
          AnalyticsManager.send(eventName, eventAttr);
        }
        onPress && onPress();
      }}
    />
  );
}
